import { render, staticRenderFns } from "./ResultPayment.vue?vue&type=template&id=6bd56c80&scoped=true&"
import script from "./ResultPayment.vue?vue&type=script&lang=js&"
export * from "./ResultPayment.vue?vue&type=script&lang=js&"
import style0 from "./ResultPayment.vue?vue&type=style&index=0&id=6bd56c80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd56c80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressCircular,VRow})
